import type {
  TIeFirstStepForm,
  TIeSecondStepForm,
  TIeThirdStepForm
} from '@/components/App/Leasing/types';
import VectorIcon from '@/media/icons/info_user.svg?react';
import Vector from '@/media/icons/lk_client.svg?react';
import Parseint from '@/media/icons/percent.svg?react';

export const REQUIRED_FIELDS: [
  Array<keyof TIeFirstStepForm>,
  Array<keyof TIeSecondStepForm>,
  Array<keyof TIeThirdStepForm>
] = [
  [
    // First step fields
    'autoType',
    'dealer',
    'initialPayment',
    'loanTerm',
    'paymentScheme',
    'subjects'
  ],
  [
    // Second step fields
    'additionalSalary',
    'birthDate',
    'childrenCount',
    'companyName',
    'contactName',
    'contactPhone',
    'contactType',
    'documentType',
    'gender',
    'jobAddress',
    'jobTitle',
    'marriageStatus',
    'salary',
    'socialStatus',
    'workPhoneNumber'
  ],
  [
    // Third step fields
    'clientPhoto',
    'docPhoto',
    'docScanSocialStatus',
    'incomeCert',
    'noticeActivity',
    'otherDoc'
  ]
];

export const NOT_REQUIRED_FIELDS: [
  Array<keyof TIeFirstStepForm>,
  Array<keyof TIeSecondStepForm>,
  Array<keyof TIeThirdStepForm>
] = [['proofInCome'], [], []];

export const stepCountItemsData: {
  title: string;
  titleMobile: string;
  totalFields: number;
  validFields: number;
  icon: React.ReactNode;
}[] = [
  {
    title: 'Информация о продукте',
    titleMobile: 'Продукт',
    totalFields: REQUIRED_FIELDS[0].length + NOT_REQUIRED_FIELDS[0].length,
    validFields: 0,
    icon: <Parseint />
  },
  {
    title: 'Личная информация',
    titleMobile: 'Личная',
    totalFields: REQUIRED_FIELDS[1].length + NOT_REQUIRED_FIELDS[1].length,
    validFields: 0,
    icon: <Vector />
  },
  {
    title: 'Доп. информация',
    titleMobile: 'Доп.Инфо',
    totalFields: REQUIRED_FIELDS[2].length + NOT_REQUIRED_FIELDS[2].length,
    validFields: 0,
    icon: <VectorIcon />
  }
];
